import classNames from 'classnames'
import styles from './BrandsSection.module.scss'
import BrandChip from '../BrandChip'

export default function BrandsSection({ content }) {
  const { sections } = content
  return (
    <div>
      {sections.map((section, i) => (
        <Section key={i} {...section} />
      ))}
    </div>
  )
}

const Section = ({ title, description, brands }) => {
  return (
    <section className={styles.section}>
      <div className="container" style={{ maxWidth: 880 }}>
        <h2 className={classNames('h2', styles.title)}>{title}</h2>
        {description && <p className={styles.description}>{description}</p>}
        <div className={styles.brandsWrapper}>
          {brands.map((brand) => {
            const hasBrandPage = brand?.description
            const link = hasBrandPage
              ? `/brands/${brand.slug}`
              : brand.url || undefined

            return (
              <BrandChip
                key={brand.slug}
                name={brand.name}
                src={brand.logo.src}
                bgFill={brand.logo.bleedColor}
                href={link}
                hasBrandPage={hasBrandPage}
              />
            )
          })}
        </div>
      </div>
    </section>
  )
}
